//components
import { SplitButton } from 'primereact/splitbutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DataTableCard } from './styled';

//utils
import { FaEllipsisH } from 'react-icons/fa';
import { MdOutlineDelete, MdOutlineCancel, MdOutlineCheckCircle, MdOutlineModeEdit } from 'react-icons/md';
import { formatReal } from '../../../../../helpers';

export function PlansTable(props: any){
    const { nodes, treeFields, sortField, sortOrder, handleTableSort, handleRemovePlan, handleEditPlan, handleChangeStatusPlan } = props;

    function statusTemplate(node: any) {
        if (node.is_active) {
            return (
                <MdOutlineCheckCircle size="20" className="text-success"/>
            );
        } else {
            return (
                <MdOutlineCancel size="20" className="text-danger"/>
            );
        }
    }

    function parcelTemplate(node: any) {
        return "R$ " + formatReal(node.parcel)
    }

    function actionsTemplate(node: any) {
        let items: any = []

        items.push({
            label: <span><MdOutlineModeEdit size="20" className="mb-1 mr-1"/> Editar</span>,
            command:() => {
                handleEditPlan(node)
            }
        })

        if (node.is_active) {
            items.push({
                label: <span><MdOutlineCancel size="20" className="mb-1 mr-1"/> Inativar</span>,
                command:() => {
                    handleChangeStatusPlan(node.id, "inactive")
                }
            })
        } else {
            items.push({
                label: <span><MdOutlineCheckCircle size="20" className="mb-1 mr-1"/> Ativar</span>,
                command:() => {
                    handleChangeStatusPlan(node.id, "active")
                }
            })
        }

        items.push({
            label: <span><MdOutlineDelete size="20" className="mb-1 mr-1"/> Excluir</span>,
            command:() => {
                handleRemovePlan(node)
            }
        })

        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Opções</Tooltip>
                }
            >
                <div>
                    <SplitButton 
                        label="" 
                        className="p-button p-component p-button-rounded p-button-text p-button-icon-only" 
                        buttonClassName="d-none"
                        dropdownIcon={<FaEllipsisH/>}
                        model={items}
                    />
                </div>
            </OverlayTrigger>
        );
    }

    function rowClassName(node: any) {
        return {
            'p-inactive': node.is_active === false
        };
    }

    return (
        <div>
            <DataTableCard>
                <DataTable value={nodes} rowClassName={rowClassName} sortField={sortField} sortOrder={sortOrder} onSort={(e) => handleTableSort(e)} responsiveLayout="scroll">
                    {!!treeFields?.length && treeFields?.map((col: any) => {
                        if (col.statusTemplate) {
                            return <Column key={col.field} body={statusTemplate} field={col.field} header={col.header} style={ col.style } {...col} />;
                        } else if (col.actionsTemplate) {
                            return <Column key={col.field} body={actionsTemplate} field={col.field} header={col.header} style={ col.style } {...col} />;
                        } else if (col.parcelTemplate) {
                            return <Column key={col.field} body={parcelTemplate} field={col.field} header={col.header} style={ col.style } {...col} />;
                        } else {
                            return <Column key={col.field} field={col.field} header={col.header} style={ col.style } {...col} />;
                        }
                    })}
                    {props.children}                
                </DataTable>
            </DataTableCard>
        </div>
    );

}